module.exports = __webpack_public_path__ + "img/会员动态.4becb935.png";